import TPL = require("templates");

export interface ConfirmConfig {
  logo: boolean;
  title: string;
  title2?: string;
  title3?: string;
  class?: string;
  actions: [{
    label: string;
    primary: boolean;
    callback: ()=>void;
  }];
}

export class ConfirmController {

  parent;
  config;

  constructor(parent, config: ConfirmConfig) {
    this.parent = parent;
    this.config = config;
  }

  static openPrivateDinnerModal(modal, confirmCallback) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "EVENT.PRIVATE_DINNER_TITLE",
        title2: "EVENT.PRIVATE_DINNER_MESSAGE",
        logo: false,
        class: "ot-small",
        actions: [
          {
            label: "EVENT.MODAL_CLOSE",
            primary: true,
            callback: confirmCallback
          }
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm,
      windowClass: 'center-modal'
    });
  }

  static openPasswordChangeDoneModal(modal) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "CHANGE_PASSWORD.CHANGE_DONE",
        logo: true,
        class: "ot-small",
        actions: null
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }

  static openForgotPasswordDoneModal(modal) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "FORGOT.MAIL_SENT",
        logo: true,
        class: "ot-small",
        actions: null
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }


  static openConfirmDeleteEventModal(modal, confirmCallback, cancelCallback) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "EVENT.CONFIRM_DELETE_TITLE",
        title2: "EVENT.CONFIRM_DELETE_TITLE2",
        logo: false,
        actions: [
          {
            label: "EVENT.CONFIRM_DELETE_SUBMIT",
            primary: true,
            callback: confirmCallback
          },
          {
            label: "EVENT.CONFIRM_DELETE_CANCEL",
            primary: false,
            callback: cancelCallback
          },
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }

  static openConfirmDeleteReservationModal(modal, confirmCallback, cancelCallback) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "EVENT.CONFIRM_DELETE_RESERVATION_TITLE",
        title2: "EVENT.CONFIRM_DELETE_RESERVATION_TITLE2",
        logo: false,
        actions: [
          {
            label: "EVENT.CONFIRM_DELETE_SUBMIT",
            primary: true,
            callback: confirmCallback
          },
          {
            label: "EVENT.CONFIRM_DELETE_CANCEL",
            primary: false,
            callback: cancelCallback
          },
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }

  static openRequestHostModal(modal, confirmCallback, cancelCallback) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "PROFILE.CONFIRM_HOST_TITLE",
        title2: "PROFILE.CONFIRM_HOST_TITLE2",
        logo: false,
        actions: [
          {
            label: "PROFILE.CONFIRM_HOST_SUBMIT",
            primary: true,
            callback: confirmCallback
          },
          {
            label: "PROFILE.CONFIRM_HOST_CANCEL",
            primary: false,
            callback: cancelCallback
          },
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }


  /*
  static openRequestHostDoneModal(modal) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "PROFILE.CONFIRM_TITLE",
        title2: "PROFILE.CONFIRM_TITLE",
        logo: true,
        actions: null
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }
  */

  static openImageTooLargeModal(modal) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "EVENT.IMAGE_TOO_LARGE_TITLE",
        title2: "EVENT.IMAGE_TOO_LARGE_SUBTITLE",
        logo: true,
        actions: null
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }

  static openSaveDataModal(modal, saveDataCallback, dropDataCallback, backCallback) {
    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "CREATE.MODAL_TITLE",
        title2: "CREATE.MODAL_SUBTITLE",
        title3: "CREATE.MODAL_SUGGESTION",
        logo: false,
        actions: [
          {
            label: "CREATE.MODAL_ACTION_KEEP",
            primary: true,
            callback: saveDataCallback
          },
          {
            label: "CREATE.MODAL_ACTION_DISCARD",
            primary: true,
            callback: dropDataCallback
          },
          {
            label: "CREATE.MODAL_ACTION_BACK",
            primary: false,
            callback: backCallback
          },
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }


  static openReservationDonePublicModal(modal, shareCallback, browseCallback, backCallback) {
    return ConfirmController.openReservationDoneModal(modal,
      "EVENT.SUCCESS_CONTENT_PUBLIC", shareCallback, browseCallback, backCallback);
  }

  static openReservationDoneManualModal(modal, shareCallback, browseCallback, backCallback) {
    return ConfirmController.openReservationDoneModal(modal,
      "EVENT.SUCCESS_CONTENT_PENDING", shareCallback, browseCallback, backCallback);
  }

  private static openReservationDoneModal(modal, content, shareCallback, browseCallback, backCallback) {

    return modal.open({
      controller: () => new ConfirmController(this, {
        title: "EVENT.SUCCESS_TITLE",
        title2: content,
        logo: false,
        actions: [
          /*{
            label: "EVENT.SUCCESS_SHARE",
            primary: true,
            callback: shareCallback
          },*/
          {
            label: "EVENT.SUCCESS_BROWSE",
            primary: true,
            callback: browseCallback
          },
          {
            label: "EVENT.SUCCESS_BACK",
            primary: false,
            callback: backCallback
          },
        ]
      }),
      controllerAs: "vm",
      replace: true,
      size: "sm",
      template: TPL.modals.confirm
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/confirm.ts
 **/